//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BcIso9001Certificate from '@/components/svg/bc-iso-9001-certificate.vue';
import BcIsoCertificate from '@/components/svg/bc-iso-certificate.vue';
import BcNenCertificate from '@/components/svg/bc-nen-certificate.vue';
import DutchLaravelFoundation from '@/components/svg/dutch-laravel-foundation.vue';
import LaravelCertificate from '@/components/svg/laravel-certificate.vue';
import PageHeader from '@/components/page/header.vue';

export default {
    components: {
        BcIso9001Certificate,
        BcIsoCertificate,
        BcNenCertificate,
        DutchLaravelFoundation,
        LaravelCertificate,
        PageHeader,
    },
    scrollToTop: true,
    head() {
        return {
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('page_title'),
                },
            ],
            title: this.$t('page_title'),
        };
    },
};
